import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Automatically scrolls to top of page when route changes
 * This fixes the issue where scroll position is retained when navigating between pages
 */
function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to top instantly when route changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant' // Use 'instant' for immediate scroll, or 'smooth' for animated
        });
    }, [pathname]);

    return null; // This component doesn't render anything
}

export default ScrollToTop;
